import React from 'react';
import './Reset.css';

export default function Reset (props) {

    return (
        <div className = "reset" onClick = {props.reset}>
        AC
        </div>
    )
    
} 